module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C120",
    attrs: {
      "id": "page_VII"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "C121"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0006#page_i"
    }
  }, [_vm._v("Foreword to "), _c('em', [_vm._v("The Cullen Collection")])])]), _vm._v(" "), _c('p', {
    staticClass: "C121"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0007#page_v"
    }
  }, [_vm._v("Introduction to "), _c('em', [_vm._v("Annals of a Quiet Neighbourhood")])])]), _vm._v(" "), _c('p', {
    staticClass: "C122"
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTE")]), _vm._v(": As the introductions to the 37 volumes of "), _c('em', [_vm._v("The Cullen Collection")]), _vm._v(" form a continuous portrait of George MacDonald’s life, and as many of the introductions contain comprehensive and detailed discussion and analysis of the title in question—its plot, themes, and circumstances of writing—some first-time readers may choose to skip ahead to the story itself, saving the introduction for later, so as not to “spoil the story.”")]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0009#page_1"
    }
  }, [_vm._v("1. Walk About a New Town")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0010#page_5"
    }
  }, [_vm._v("2. Old Rogers")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011#page_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. What the Sunset Said")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0012#page_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. My First Sunday at Marshmallows")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0013#page_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. My First Monday at Marshmallows")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0014#page_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Mill and the Cottage")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0015#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Coffin Maker")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0016#page_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Visitors from the Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0017#page_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. More Parishioners")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0018#page_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Oldcastle Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0019#page_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Two Weirs")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0020#page_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Bishop’s Basin")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0021#page_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. What I Preached")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0022#page_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. The Organist")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0023#page_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Jane Rogers and Richard Brownrigg")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0024#page_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. My Christmas Party")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0025#page_116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. On God and Mammon")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0026#page_126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Reflections")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0027#page_131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Christmas Afternoon Visits")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0028#page_139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. The Avenue")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0029#page_145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Young Weir")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0030#page_160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Differences Healed")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0031#page_172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. My Pupil")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0032#page_179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Old Rogers’s Insight")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0033#page_185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. Dr. Duncan’s Story")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0034#page_195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. The Language of Handel")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0035#page_198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. The Church Rate")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0036#page_209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. Judy’s News")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0037#page_214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. The Invalid")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0038#page_223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. Mood and Will")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0039#page_231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. The Devil in Thomas Weir")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0040#page_236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. The Devil in Catherine Weir")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0041#page_244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. The Devil in the Vicar")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0042#page_250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. An Angel Unawares")])]), _vm._v(" "), _c('p', {
    staticClass: "C123",
    attrs: {
      "id": "page_VIII"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0043#page_256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. Two Parishioners")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0044#page_263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36. Satan Cast Out")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0045#page_273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37. The Man and the Child")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0046#page_281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38. Old Mrs. Tomkins and Samuel Weir")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0047#page_290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39. God in Catherine Weir")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0048#page_294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40. Calm and Storm")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0049#page_302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41. A Sermon to Myself")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0050#page_307",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42. A Quiet Passing")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0051#page_315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43. A Council of Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0052#page_321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44. The Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0053#page_324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45. Confrontation")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0054#page_333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46. Deliverance")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0055#page_339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47. The Parson and His Wife")])]), _vm._v(" "), _c('p', {
    staticClass: "C123"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0056#page_343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48. Tom’s Story")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e94be12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0004.vue
// module id = 72
// module chunks = 0